import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const TableIcon = ({ stroke, fill, active, ...props }) => {
  const useStyles = makeStyles({
    cls3: {
      fill,
      opacity: active ? 1 : 0.3,
      borderRadius:`0!important`
    },
  });
  const classes = useStyles();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={"45" || props.width}
      height={"25" || props.height}
      viewBox="0 0 19.704 19.704"
      className={classes.cls3}

    >
      <path
        className={classes.cls3}
        d="M2.571,3.856V24.025H25.62V3.856H2.571Zm8.644,12.965V12.5h5.762v4.322Zm5.762,1.441v4.322H11.214V18.262Zm0-11.525v4.322H11.214V6.737Zm-7.2,0v4.322H4.011V6.737ZM4.011,12.5H9.774v4.322H4.011Zm14.406,0H24.18v4.322H18.417Zm0-1.441V6.737H24.18v4.322Zm-14.406,7.2H9.774v4.322H4.011V18.262Zm14.406,4.322V18.262H24.18v4.322Z"
        transform="translate(-2.571 -3.856)" />
    </svg>
  );
};

export default TableIcon;
